import React, { memo } from 'react';

import { makeStyles } from 'tss-react/mui';
import { useQueryParams } from '../../hooks';
import SearchHeaderField from '../common/Header/SearchHeader/SearchHeaderField';

export interface IEventRootTypesProps {
  fullWidth?: boolean;
  disabled?: boolean;
  placeholder?: string;
}

const useStyles = makeStyles()(() => ({
  root: {
    paddingBottom: 12,
    width: '100%',
  },
}));

const EventSearchFilter: React.FC<React.PropsWithChildren<IEventRootTypesProps>> = (props) => {
  const { fullWidth, disabled, placeholder } = props;
  const [queryParams, setQueryParams] = useQueryParams();
  const { classes } = useStyles();

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    setQueryParams({
      ...queryParams,
      ...{ search: event.target?.value },
    });
  };

  const searchTerm = (): string => queryParams.search?.toString() || '';

  return (
    <div className={classes.root}>
      <SearchHeaderField
        inputValue={searchTerm()}
        onChange={handleOnChange}
        fullWidth={fullWidth}
        disabled={disabled}
        placeholder={placeholder}
      />
    </div>
  );
};

export default memo(EventSearchFilter);
